export type PlanFeatures = {
  approvalGroups: boolean;
  escalationRules: boolean;
};

export const planFeaturesFromEntitlements = (
  entitlements: Record<string, unknown> | undefined
): PlanFeatures => ({
  approvalGroups: entitlements?.feature_approval_groups === true,
  escalationRules: entitlements?.feature_escalation_rules === true
});
